export const trackProductView = (
  selectedProduct: FlattenedProduct | null,
  group: string,
  location: string,
  locale: Locales,
  options?: { productAssociations?: ProductAssociationsDataLayer },
) => {
  if (!selectedProduct) {
    return
  }

  const event = 'custom.product.detail.view'

  pushEventToDataLayer(event, {
    group,
    category: 'ecommerce/product',
    label: selectedProduct.name,
    info: {
      location: location || 'product page',
    },
    data: undefined,
    ecommerceType: 'detail',
    ecommerce: {
      currencyCode: selectedProduct?.currency,
      detail: {
        products: [
          mapProductToDataLayer(selectedProduct, locale, {
            list: location || 'product page',
            productAssociations: options?.productAssociations,
          }),
        ],
      },
    },
  })
}

export const trackProductAttributeChange = (product: FlattenedProduct, attribute: { name: string; value: string }) => {
  pushEventToDataLayer('custom.product.attribute.change', {
    group: 'product',
    label: product.name,
    sku: product.id,
    info: {
      title: attribute.name,
      value: attribute.value.toLowerCase(),
    },
  })
}
